import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f85c5c50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_toolbar = _resolveComponent("top-toolbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_top_toolbar, {
      onUserSelectPath: _ctx.userSelectPath,
      collapsed: _ctx.props.collapsed
    }, null, 8, ["onUserSelectPath", "collapsed"])
  ]))
}